import { Component } from '@angular/core';
import { AmplitudeService } from '../../services/amplitude.service';
import { WhatsappService } from '../../services/whatsapp.service';

@Component({
  selector: 'icon-button-whatsapp',
  template: `
    <button (click)="openWhatsApp()" mat-icon-button color="primary" matTooltip="Ajuda">
      <mat-icon>contact_support</mat-icon>
    </button>
  `,
  standalone: false
})
export class IconButtonWhatsappComponent {

  constructor(
    private amplitudeService: AmplitudeService,
    private whatsappService: WhatsappService,
  ) {
  }

  openWhatsApp() {
    this.amplitudeService.sendEvent('contact_support_clicked', {
      stepName: location.pathname,
    });
    const msg = 'Olá, estou com dúvidas no processo preventivo e gostaria de ajuda.';
    this.whatsappService.sendMessage(msg, { oId: true });

  }
}
